import { Component, OnInit } from '@angular/core';
import { UserPermissions } from '../../domain/security/user-permissions';
import { PermissionsStoreService } from '../../services/stores/permission-store-service';
import { Observable, firstValueFrom } from 'rxjs';
import { MessageService } from 'primeng/api';

@Component({
   selector: 'app-audit-basket-list',
   templateUrl: './audit-basket-list.component.html',
   styleUrls: ['./audit-basket-list.component.scss'],
   providers: [MessageService]
})
export class AuditBasketListComponent implements OnInit {
   userPermissions$!: Observable<UserPermissions>;

   constructor(
      private permissionsStore: PermissionsStoreService,
      private service: MessageService
   ) {}

   ngOnInit(): void {
      this.userPermissions$ = this.permissionsStore.get();
   }
   async createNewAuditBasket() {
      try {
         const permissions = await firstValueFrom(this.userPermissions$);

         if (permissions?.hasCreateAudit) {
            return;
         }

         this.service.add({
            key: 'tst',
            severity: 'error',
            summary: 'Access Exception',
            detail:
               'You do not have the permissions to create an audit basket, please contact support if required'
         });
      } catch (e) {
         this.service.add({
            key: 'tst',
            severity: 'error',
            summary: 'Error',
            detail: 'Unable to load permissions. Please refresh and try again.'
         });
      }
   }
}
